export const getZoneTooltip = (type: string) => {
    let text = '';
  
    switch(type) {
      case 'Booth':
        text = 'An area of a B2B or B2C tradeshow for brands to promote their business and products';
        break;
      case 'Cohort':
        text = 'Designated for a group of visitors that exhibit a distinct behaviour. Examples include families, VIPs, product specific cohorts.';
        break;
      case 'Entertainment':
        text = 'An area to consume entertainment such as a performance, panel or speakership';
        break;
      case 'Entrance / Exit':
        text = 'Designated for entrances and exits of events and experiences';
        break;
      case 'Experiential':
        text = 'An experiential activation or a subset of an experiential activation.';
        break;
      case 'Food & Beverage':
        text = 'An area to acquire food and beverage products.';
        break;
      case 'Merchandise':
        text = 'An area to purchase merchandise from an event.';
        break;
      case 'Operational':
        text = 'A sensor designated to measure an operational area of an event or experience such as queue or bottleneck.';
        break;
      case 'Other':
        text = 'An area or asset that is not represented in the following options. Please contact your Meshh Account Manager with feedback to include in future options.';
        break;
      case 'Retail':
        text = 'A store or pop up retail experience';
        break;
      case 'Sampling':
        text = 'An experience or pop-up providing samples of their products.';
        break;
      case 'Screen':
        text = 'A screen at an event or experience that provides related content';
        break;
      case 'Seating':
        text = 'An area of an event or experience for visitors to sit.';
        break;
      case 'Sponsor Asset':
        text = 'An asset or subset of an asset a part of a paid sponsorship package. Examples include: Activation, Signage, Sponsored area, Logo.';
        break;
      default:
        text = '';
        break;
    }
  
    return text;
}  